import React, { useEffect, useRef, useState } from "react";
import {
  getDayDiffBetweenFiscalMonths,
  getDaysInFYMonths,
  secondsToHHMM,
  timeToSeconds,
} from "../../../../Utilitie";
import { afYearlyTHead, ahWiseTHead, remarkTableHeader } from "../AFHelper";
import DynamicTable from "../../../../Extra/DynamicTable";
import { PiGreaterThan } from "react-icons/pi";
import { RiResetLeftFill } from "react-icons/ri";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const shifts = ["00_08", "08_16", "16_24"];
const di = ["UP", "BI", "DN"];

const AssetFailureYearly = ({ data, more }) => {
  const year1 = useRef();
  const year2 = useRef();
  const tableRef = [year1, year2];
  const tableYear = useRef();
  const tableShift = useRef();
  const tableDirection = useRef();
  const [filters, setFilters] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        return item[key] === value;
      });
    });
  }
  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setFilteredData(filterData((data, filters)));
    } else {
      setFilteredData(data);
    }
  }, [filters, data]);

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <h4>year wise</h4>
          <div className="table-responsive newUiBody">
            <table
              className="table  newUiTable table-hover border table-striped "
              ref={tableYear}
            >
              <thead className="table-dark">
                <tr>
                  <td> Sr</td>
                  {afYearlyTHead.map((head, i) => {
                    return <td key={i}>{head}</td>;
                  })}
                </tr>
              </thead>
              <tbody>
                {more &&
                  more?.years?.map((year, i) => {
                    let temp = data.filter((a) => a.F_YEAR === year);
                    let months = [...new Set(temp.map((t) => t["A_MONTH"]))];
                    let days = temp ? getDaysInFYMonths(year, months) : 1;
                    return (
                      <tr
                        className={
                          year === filters.F_YEAR &&
                          `border border-primary table-primary`
                        }
                        key={i}
                        style={{ cursor: "pointer" }}
                        onClick={() => setFilters({ ...filters, F_YEAR: year })}
                      >
                        <td>{i + 1}</td>
                        <td>{year}</td>
                        <td>{temp.length}</td>
                        <td>{(temp.length / days).toFixed(2)}</td>
                        <td>
                          {secondsToHHMM(
                            (
                              temp.reduce((sum, obj) => {
                                return (
                                  sum +
                                  obj.Average_Detention_Time_Mins_Total_20 * 60
                                );
                              }, 0) / days
                            ).toFixed(0)
                          )}
                        </td>
                        <td>
                          {temp.reduce((sum, o) => {
                            return sum + Number(o.No_of_Trains_DelayedG_16);
                          }, 0)}
                        </td>
                        <td>
                          {temp.reduce((sum, o) => {
                            return sum + Number(o.No_of_Trains_DelayedP_15);
                          }, 0)}
                        </td>
                        <td>
                          {temp.reduce((sum, o) => {
                            return sum + Number(o.No_of_Trains_DelayedTotal_17);
                          }, 0)}
                        </td>

                        <td>
                          {" "}
                          {secondsToHHMM(
                            temp.reduce((sum, obj) => {
                              return (
                                sum +
                                obj.Average_Detention_Time_Mins_Total_20 * 60
                              );
                            }, 0)
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <DownloadExcel tableRef={tableYear} fileName={`AF year Wise `} />
          </div>
        </div>
        <div className="col-md-3">
          <h4>Shift wise</h4>
          <div className="table-responsive newUiBody">
            <table
              className="table newUiTable table-hover border table-striped "
              ref={tableShift}
            >
              <thead className="table-dark">
                <tr>
                  <td>Sno</td>
                  <td>Shift</td>
                  <td> AF Case</td>
                  <td>%</td>
                </tr>
              </thead>
              <tbody>
                {shifts.map((shift, i) => {
                  let afc = data.filter((f) => f.SHIFT === shift).length;
                  return (
                    <tr
                      className={
                        shift === filters.SHIFT &&
                        `border border-primary table-primary`
                      }
                      key={1}
                      style={{ cursor: "pointer" }}
                      onClick={() => setFilters({ ...filters, SHIFT: shift })}
                    >
                      <td>{i + 1}</td>
                      <td>{shift.replace("_", "-")}</td>
                      <td>{afc}</td>
                      <td>{((afc / data.length) * 100).toFixed(1)}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <DownloadExcel tableRef={tableShift} fileName={`AF shift Wise `} />
          </div>
        </div>
        <div className="col-md-3">
          <h4>Direction Wise</h4>
          <div className="table-responsive newUiBody ">
            <table
              className="table newUiTable table-hover border  table-striped"
              ref={tableDirection}
            >
              <thead className="table-dark">
                <tr>
                  <td>Sno</td>
                  <td>Shift</td>
                  <td> AF Case</td>
                  <td>%</td>
                </tr>
              </thead>
              <tbody>
                {di.map((d, i) => {
                  let afc = data.filter((f) => f.UP_DOWN === d).length;
                  return (
                    <tr
                      className={
                        d === filters.UP_DOWN &&
                        `border border-primary table-primary`
                      }
                      key={1}
                      style={{ cursor: "pointer" }}
                      onClick={() => setFilters({ ...filters, UP_DOWN: d })}
                    >
                      <td>{i + 1}</td>
                      <td>{d}</td>
                      <td>{afc}</td>
                      <td>{((afc / data.length) * 100).toFixed(1)}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <DownloadExcel
              tableRef={tableDirection}
              fileName={`AF Direction wise `}
            />
          </div>
        </div>
      </div>
      <hr className="m-0 p-0" />
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">Year Wise Asset Failure</h4>
        </div>
        <div className="row">
          {more &&
            more?.years?.map((year, j) => {
              let temp = data.filter((a) => a.F_YEAR === year);
              let months = [...new Set(temp.map((t) => t["A_MONTH"]))];
              let days = temp ? getDaysInFYMonths(year, months) : 1;
              let assetHead = [...new Set(temp.map((o) => o.ASSET_GROUP))];

              return (
                <div key={j} className="col-md-6">
                  <div className=" ">
                    <div className=" ">
                      <h4 className="text-white bg-dark"> {year}</h4>
                    </div>
                    <div className="table-responsive newUiBody">
                      <table
                        className="table newUiTable table-striped table-hover"
                        ref={tableRef[j]}
                      >
                        <thead className="table-dark">
                          <tr>
                            {ahWiseTHead.map((head, i) => {
                              <th>Sr</th>;
                              return <th key={i}>{head}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {assetHead.map((ah, q) => {
                            let fData = temp.filter(
                              (t) => t.ASSET_GROUP === ah
                            );
                            return (
                              <tr
                                className={
                                  year === filters.F_YEAR &&
                                  ah === filters.ASSET_GROUP &&
                                  `border border-primary table-primary`
                                }
                                key={10 * q}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    F_YEAR: year,
                                    ASSET_GROUP: ah,
                                  })
                                }
                              >
                                <td>{ah}</td>
                                <td>{fData.length}</td>
                                <td>{(fData.length / days).toFixed(2)}</td>
                                <td>
                                  {secondsToHHMM(
                                    fData.reduce((sum, t) => {
                                      return (
                                        sum +
                                        t.Average_Detention_Time_Mins_Total_20 *
                                          60
                                      );
                                    }, 0) / days
                                  )}
                                </td>{" "}
                                <td>
                                  {fData.reduce((sum, o) => {
                                    return (
                                      sum +
                                      Number(o.No_of_Trains_DelayedTotal_17)
                                    );
                                  }, 0)}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    fData.reduce((sum, t) => {
                                      return (
                                        sum +
                                        t.Average_Detention_Time_Mins_Total_20 *
                                          60
                                      );
                                    }, 0)
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <DownloadExcel
                        tableRef={tableRef[j]}
                        fileName={`AF year Wise -${year}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* ////////////////////////////////////////////////////////////////////////// */}
      <div
        className="row
      "
      >
        {filteredData && (
          <div>
            <div className="  bg-dark text-white pe-2 ps-2">
              {" "}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center ">
                  <h4>Failure Remarks for - </h4>
                  <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                    {Object.entries(filters).map(([key, value], i) => {
                      return i === 0 ? (
                        <h6 key={i}>{value}</h6>
                      ) : (
                        <h6 key={i}>
                          <PiGreaterThan />
                          {value}
                        </h6>
                      );
                    })}
                  </div>
                </div>
                <div>
                  {" "}
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => setFilters({})}
                  >
                    <RiResetLeftFill />
                  </button>
                </div>
              </div>
            </div>
            <DynamicTable
              data={filteredData}
              headers={remarkTableHeader}
              rowsPerPage={15}
              fontSize={"12px"}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default AssetFailureYearly;
